/**
 * ADR-071 Rule FE-04 (OQ-FE-01 بسته شد).
 *
 * توکن‌ها در sessionStorage نگه‌داری می‌شوند تا با هر reload صفحه لاگین از بین نرود.
 * مکانیزم refresh فقط بر پایه body است (چون بک‌اند همین‌گونه پیاده‌سازی شده).
 *
 * AM-051-01.5: پرچم is_superuser فقط «راهنمای UX» است تا کلاینت بداند چه زمانی هدر X-Tenant-Id
 * را بفرستد. هیچ تصمیم امنیتی‌ای از روی آن گرفته نمی‌شود؛ سرور همیشه از session.user.is_superuser
 * تصمیم می‌گیرد و هدر کاربران عادی را نادیده می‌گیرد.
 */

export const tokenStorage = {
  getAccessToken(): string | null {
    return sessionStorage.getItem("access_token");
  },

  setAccessToken(token: string | null): void {
    if (token) sessionStorage.setItem("access_token", token);
    else sessionStorage.removeItem("access_token");
  },

  getRefreshToken(): string | null {
    return sessionStorage.getItem("refresh_token");
  },

  setRefreshToken(token: string | null): void {
    if (token) sessionStorage.setItem("refresh_token", token);
    else sessionStorage.removeItem("refresh_token");
  },

  getTenantId(): string | null {
    return sessionStorage.getItem("tenant_id");
  },

  setTenantId(tenantId: string | null): void {
    if (tenantId) sessionStorage.setItem("tenant_id", tenantId);
    else sessionStorage.removeItem("tenant_id");
  },

  /** AM-051-01.5 — فقط UX؛ هرگز مبنای مجوز نیست. */
  isSuperuser(): boolean {
    return sessionStorage.getItem("is_superuser") === "1";
  },

  setIsSuperuser(value: boolean): void {
    if (value) sessionStorage.setItem("is_superuser", "1");
    else sessionStorage.removeItem("is_superuser");
  },

  clear(): void {
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("refresh_token");
    sessionStorage.removeItem("tenant_id");
    sessionStorage.removeItem("is_superuser");
  },
};
